import { render } from "./ToggleButton.vue?vue&type=template&id=0f8cbe07&scoped=true"
import script from "./ToggleButton.vue?vue&type=script&lang=js"
export * from "./ToggleButton.vue?vue&type=script&lang=js"

import "./ToggleButton.vue?vue&type=style&index=0&id=0f8cbe07&scoped=true&lang=stylus"

import exportComponent from "F:\\xampp\\htdocs\\GITLAB\\2025\\tokyo-shoseki\\r7\\gi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f8cbe07"]])

export default __exports__